import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import AddCategoryList from "../../core/modals/inventory/addcategorylist";
import EditCategoryList from "../../core/modals/inventory/editcategorylist";
import Swal from "sweetalert2";
import Table from "../../core/pagination/datatable";
import { deleteCategory } from "../../slices/productSlice";
import { PlusCircle } from "feather-icons-react/build/IconComponents";
import { deleteProductCategory } from "../../api/inventoryApi";


const CategoryList = () => {
  const dataSource = useSelector((state) => state.products.categories);
  const dispatch = useDispatch();

  const [selectedCategory, setSelectedCategory] = useState(null); 
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);

 
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    // {
    //   title: "Created At",
    //   dataIndex: "created_at",
    //   sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),

    // },
    {
      title: "Statut",
      dataIndex: "statut",
      render: () => (
        <span className="badge badge-linesuccess">
          <Link to="#">Actif</Link>
        </span>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="action-table-data">
          <button
            className="btn btn-sm btn-primary me-2"
            onClick={() => handleEdit(record)}
            data-bs-target="#edit-category"
            data-bs-toggle="modal"

          >
            <i data-feather="edit" className="feather-edit"></i>
          </button>
          <button
            className="btn btn-sm btn-danger"
            onClick={() => handleDelete(record.id)}
          >

            <i data-feather="trash-2" className="feather-trash-2"></i>
          </button>
        </div>
      ),
    },
  ];
  
  const deleteFunction = async (categoryId) => {
    try {
      const response = await deleteProductCategory(categoryId);
  
      if (response?.error) {
        // Gestion des erreurs retournées par le serveur
        Swal.fire("Erreur", response.error.message || "Une erreur est survenue.", "error");
      } else {
        Swal.fire("Supprimé !", "Votre catégorie a été supprimée avec succès.", "success");
      }
    } catch (error) {
      // Gestion des erreurs inattendues (réseau, serveur non joignable, etc.)
      Swal.fire(
        "Erreur",
        error?.response?.data?.message || "Une erreur imprévue est survenue.",
        "error"
      );
    }
  };
  

  // Gestion de l'ouverture de l'éditeur
  const handleEdit = (category) => {

    setSelectedCategory(category);

    setIsEditModalVisible(true);
    
  };

  // Gestion de la suppression
  const handleDelete = (id) => {
    Swal.fire({
      title: "Êtes-vous sûr?",
      text: "Vous ne pourrez pas revenir en arrière !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Oui, supprimez-le !",
      cancelButtonText: "Non, annulez !",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteCategory(id)); 
        deleteFunction(id);
      }
    });
  };
  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Catégories</h4>
                <h6>Gérez vos catégories</h6>
              </div>
            </div>
           
            <div className="page-btn">
              <Link
                to="#"
                className="btn btn-added"
                data-bs-toggle="modal"
                data-bs-target="#add-category"
              >
                <PlusCircle className="me-2" />
                Ajouter une nouvelle catégorie
              </Link>
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-body">
              
            
              <div className="table-responsive">
                <Table columns={columns} dataSource={dataSource} />
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>
      <AddCategoryList />
      {/* Modal d'édition */}
      {isEditModalVisible && (
        <EditCategoryList
          category={selectedCategory}
          onClose={() => setIsEditModalVisible(false)}
        />
      )}
      
      </div>
  );
};

export default CategoryList;
